export const entityRoutePaths = {
    root: "entities/",
    list: "",
    add: "add",
    edit: "edit",
};
